import styled from "styled-components";
import { Tooltip } from "react-tooltip";
import { useRef } from "react";

import * as css from "styles/CssVariables.js";
import {
  dateFormatted,
  getTimeAMPM,
  numberWithCommas,
} from "modules/functions";
import { COUNTRY_ICONS } from "constants/countries";
import ButtonRoundIcon from "components/buttons/ButtonRoundIcon";

import blockIcon from "assets/img/icons/icons8-unavailable.svg";
import leftIcon from "assets/img/icons/left-arrow.svg";
import rightIcon from "assets/img/icons/right-arrow.svg";
import leftWhiteIcon from "assets/img/icons/left-arrow-white.svg";
import rightWhiteIcon from "assets/img/icons/right-arrow-white.svg";

const TransactionList = styled.div`
  display: flex;
  flex-direction: column;
`;

const TransactionListBox = styled.div`
  width: 100%;
  min-height: 280px;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 10px;
`;

const TableWrap = styled.div`
  width: 100%;
  padding-bottom: 5px;
  margin-bottom: -5px;

  overflow-x: auto;
`;

const ListTable = styled.table`
  width: 100%;
  min-width: 560px;
  max-width: 700px;
`;

const TableHead = styled.thead``;

const Label = styled.th`
  padding-bottom: 12px;
  max-width: ${(props) => (props.width ? props.width : "auto")};

  font-size: 18px;
  font-weight: 400;
  text-align: left;
`;

const TableBody = styled.tbody``;

const Cell = styled.td``;

const AmountBox = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const Badge = styled.div`
  height: 22px;
  margin: 4px;
  padding: 0px 8px;

  font-size: 13px;

  border-radius: 11px;
  background: ${(props) =>
    props.green ? css.POSITIVE_GREEN : css.NEGATIVE_RED};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const DetailsWrap = styled.div`
  width: 100%;
  max-width: 210px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Pagination = styled.div`
  width: 100%;
  margin-top: ${css.VERTICAL_BOX_MARGIN_MEDIUM};

  display: flex;
  justify-content: center;
  gap: ${css.BUTTONS_GAP_SMALL};
`;

const NoResults = styled.div`
  width: 100%;
  margin-top: 75px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const NoResultsIcon = styled.div`
  width: 32px;
  min-width: 32px;
  height: 32px;
`;

const TypeImpression = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const TypeImpressionText = styled.div``;

const CountryIcon = styled.div`
  padding-top: 1px;

  width: 18px;
  min-width: 18px;
  height: 18px;

  &:hover {
    cursor: help;
  }
`;

const CroppedInfoCell = styled.td`
  padding: 20px 0 10px;

  font-size: 13px;
  text-align: center;
`;

const NoResultsText = styled.div``;

export default ({ data, page, limit, paginate }) => {
  const { transactions, numOfResults, croppedData } = data.transactionList;

  console.log("transactions", transactions);

  const list = transactions.map((transaction) => {
    const { id, created_at, type, data, amount } = transaction;

    let typeText;
    let details;

    switch (type) {
      case "impression":
        const icon = COUNTRY_ICONS[data.country]
          ? COUNTRY_ICONS[data.country].icon
          : null;

        typeText = (
          <TypeImpression>
            {icon && (
              <>
                <CountryIcon
                  data-tooltip-id="countryTip"
                  data-tooltip-html={data.country}
                  data-tooltip-place="top"
                  data-tooltip-delay-show={500}
                  onClick={(e) => e.stopPropagation()}
                >
                  <img src={icon} width="100%" alt={data.country} />
                </CountryIcon>
                <Tooltip id="countryTip" className="tooltip" />
              </>
            )}
            <TypeImpressionText>Impression</TypeImpressionText>
          </TypeImpression>
        );
        details = data.postName;
        break;
      case "rewardsPayout":
        typeText = "Coins found";
        if (data.streak_bonus) {
          const plural = data.streak_bonus > 1 ? "s" : "";

          details = `Including ${data.streak_bonus} coin${plural} Streak bonus`;
        }
        break;
      case "referralReward":
        typeText = "Referral reward";
        details = data.referral_username;
        break;
      case "purchase":
        typeText = "Purchase";
        details = numberWithCommas(amount) + " Coins Package";
        break;
      case "cashCoinsConversion":
        typeText = "Cash conversion";
        details = data.cash + " USD";
        break;
      case "promoBonus":
        typeText = "Bonus";
        details = "";
        break;
      case "bonus":
        typeText = "Bonus";
        details = "";
        break;
      case "coinsConversion":
        typeText = "Coins conversion";
        details = data.cash + " USD";
        break;
      case "purchaseDailyCoins":
        let adPlanName;

        switch (data.ad_plan) {
          case 1:
            adPlanName = "Bronze";
            break;
          case 2:
            adPlanName = "Silver";
            break;
          case 3:
            adPlanName = "Gold 20";
            break;
          case 4:
            adPlanName = "Gold 40";
            break;
          case 5:
            adPlanName = "Gold 60";
            break;
          case 6:
            adPlanName = "Gold 80";
            break;
          case 7:
            adPlanName = "Gold 100";
            break;
        }

        typeText = "Ad plan coins";
        details = adPlanName + " plan";

        break;
      case "referralRewardReversal":
        typeText = "Referral reward";
        details = " Reversal";
        break;
    }

    return (
      <tr key={id}>
        <Cell>
          {dateFormatted(new Date(created_at), false) +
            ", " +
            getTimeAMPM(new Date(created_at))}
        </Cell>
        <Cell>{typeText}</Cell>
        <Cell>
          <AmountBox>
            {/* <CoinsIcon>
              <img src={coinsIcon} style={{ width: "100%" }} />
            </CoinsIcon> */}
            <Badge green={amount >= 0 ? 1 : 0}>
              {numberWithCommas(amount)}
            </Badge>
          </AmountBox>
        </Cell>
        <Cell>
          <DetailsWrap>{details}</DetailsWrap>
        </Cell>
      </tr>
    );
  });

  // prepare pagination
  let showPagination = false;

  if (numOfResults > limit) showPagination = true;

  const maxPage = Math.ceil(numOfResults / limit);

  console.log({ croppedData, numOfResults, page, maxPage });

  if (croppedData && page >= maxPage) {
    list.push(
      <tr key="croppedMessage">
        <CroppedInfoCell colspan="4">
          Only transactions from the last 14 days are available.
        </CroppedInfoCell>
      </tr>,
    );
  }

  console.log("list.length", list.length);

  return (
    <TransactionList>
      <TransactionListBox>
        <TableWrap className="table-wrap">
          {list.length > 0 && (
            <ListTable>
              <TableHead>
                <tr>
                  <Label width="150px">Date</Label>
                  <Label width="130px">Type</Label>
                  <Label width="90px">Amount</Label>
                  <Label>Details</Label>
                </tr>
              </TableHead>
              <TableBody>{list}</TableBody>
            </ListTable>
          )}
          {list.length === 0 && (
            <NoResults>
              <NoResultsIcon>
                <img src={blockIcon} style={{ width: "100%" }} />
              </NoResultsIcon>
              <NoResultsText>
                You don't have any transactions yet.
              </NoResultsText>
            </NoResults>
          )}
        </TableWrap>
        {showPagination && (
          <Pagination>
            {page > 1 && (
              <ButtonRoundIcon
                icon={leftIcon}
                hoverIcon={leftWhiteIcon}
                background={css.BRAND_YELLOW}
                hoverBackground={css.BRAND_GREEN}
                iconSize="16px"
                buttonSize="32px"
                onClick={() => paginate("previous")}
              />
            )}
            {page < maxPage && (
              <ButtonRoundIcon
                icon={rightIcon}
                hoverIcon={rightWhiteIcon}
                background={css.BRAND_YELLOW}
                hoverBackground={css.BRAND_GREEN}
                iconSize="16px"
                buttonSize="32px"
                onClick={() => paginate("next")}
              />
            )}
          </Pagination>
        )}
      </TransactionListBox>
    </TransactionList>
  );
};
